
import Gallery from "../../../assets/duotone/Gallery.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GalleryIcon({ className, dataTestid = "GalleryIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Gallery data-testid={dataTestid} className={classes} {...rest} />
  );
}
